import moment from "moment";

export const DATE_FORMAT = 'DD-MMM-YYYY HH:mm:ss';

export const normalizeUserReports = reports => reports.map(r => {
  r['date_created'] = moment(r.date_created, DATE_FORMAT);
  return r;
});